// assets
import { countries } from 'src/assets/data';
//
import { _mock } from './_mock';

// ----------------------------------------------------------------------


export const GET_USER_LIST = [
  {
    "deletedAt": null,
    "_id": "6780bb7e3825ccf3bcc298d3",
    "email": "rm@gmail.com",
    "roleId": "677fcc15f316eeb37a749b00",
    "firstName": "M Uzair",
    "lastName": "Shahid Rao",
    "regionId": "6780bafd3825ccf3bcc2989a",
    "officeId": "",
    "city": "Lahore Cantt, Lahore",
    "street": "Hazrat Usman St, Ali Park",
    "zipCode": "51000",
    "divisionId": "6780bae93825ccf3bcc29860",
    "phoneNo": "+1 (123) 123-1233",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "createdAt": "2025-01-10T06:17:34.981Z",
    "updatedAt": "2025-01-10T11:02:09.552Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b00",
      "name": "Regional Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "Regional Manager",
      "rolesParentId": "677fcc15f316eeb37a749afe"
    },
    "id": "6780bb7e3825ccf3bcc298d3"
  },
  {
    "deletedAt": null,
    "_id": "6780bcca3825ccf3bcc299ad",
    "email": "cm@gmail.com",
    "roleId": "677fcc15f316eeb37a749b02",
    "firstName": "M Uzair",
    "lastName": "Shahid Rao",
    "regionId": "",
    "officeId": "6780ba9e3825ccf3bcc2982c",
    "city": "Lahore Cantt, Lahore",
    "street": "Hazrat Usman St, Ali Park",
    "zipCode": "51000",
    "divisionId": "6780bae93825ccf3bcc29860",
    "phoneNo": "+1 (123) 123-1231",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "createdAt": "2025-01-10T06:23:06.917Z",
    "updatedAt": "2025-01-10T11:02:02.209Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b02",
      "name": "City Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "City Manager",
      "rolesParentId": "677fcc15f316eeb37a749b00"
    },
    "id": "6780bcca3825ccf3bcc299ad"
  },
  {
    "deletedAt": null,
    "_id": "6780f4573825ccf3bcc2b2a4",
    "email": "cto@yopmail.com",
    "roleId": "677fcc15f316eeb37a749afc",
    "firstName": "CTO",
    "lastName": "Updated",
    "regionId": "",
    "officeId": "",
    "city": "",
    "street": "",
    "zipCode": "",
    "divisionId": "",
    "phoneNo": "+1 (000) 000-0001",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "createdAt": "2025-01-10T10:20:07.304Z",
    "updatedAt": "2025-01-10T10:50:04.673Z",
    "role": {
      "_id": "677fcc15f316eeb37a749afc",
      "name": "CTO",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "CTO",
      "rolesParentId": "677fcc15f316eeb37a749afa"
    },
    "id": "6780f4573825ccf3bcc2b2a4"
  },
  {
    "deletedAt": null,
    "_id": "6780f4a13825ccf3bcc2b301",
    "email": "vp@gmail.com",
    "roleId": "677fcc15f316eeb37a749afe",
    "firstName": "VP",
    "lastName": "VP",
    "regionId": "",
    "officeId": "",
    "city": "Vitae veritatis corr",
    "street": "Blanditiis impedit",
    "zipCode": "Soluta ducimus simi",
    "divisionId": "",
    "phoneNo": "+1 (000) 000-0002",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "createdAt": "2025-01-10T10:21:21.475Z",
    "updatedAt": "2025-01-10T10:31:45.236Z",
    "role": {
      "_id": "677fcc15f316eeb37a749afe",
      "name": "VP",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "VP",
      "rolesParentId": "677fcc15f316eeb37a749afc"
    },
    "id": "6780f4a13825ccf3bcc2b301"
  },
  {
    "deletedAt": null,
    "_id": "67810f913825ccf3bcc2ca6a",
    "email": "subrm@yopmail.com",
    "roleId": "678108db3825ccf3bcc2c95e",
    "firstName": "Sub",
    "lastName": "RM",
    "regionId": "",
    "officeId": "",
    "city": "Corrupti iusto aut",
    "street": "Nostrud atque et ita",
    "zipCode": "Delectus quisquam m",
    "divisionId": "",
    "phoneNo": "+1 (000) 000-0004",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "createdAt": "2025-01-10T12:16:17.960Z",
    "updatedAt": "2025-01-10T12:16:44.274Z",
    "role": {
      "_id": "678108db3825ccf3bcc2c95e",
      "name": "Sub RM",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "Description of Sub RM",
      "rolesParentId": "677fcc15f316eeb37a749b00"
    },
    "id": "67810f913825ccf3bcc2ca6a"
  },
  {
    "deletedAt": null,
    "_id": "67824bee15fd806c273bdeb0",
    "email": "rm22@gmail.com",
    "roleId": "677fcc15f316eeb37a749b00",
    "firstName": "r",
    "lastName": "m",
    "regionId": "6780cad73825ccf3bcc2a09e",
    "officeId": "",
    "city": "",
    "street": "",
    "zipCode": "",
    "divisionId": "6780bae93825ccf3bcc29860",
    "phoneNo": "+1 (112) 312-3123",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "email sent",
    "createdAt": "2025-01-11T10:46:07.064Z",
    "updatedAt": "2025-01-11T10:46:07.064Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b00",
      "name": "Regional Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "Regional Manager",
      "rolesParentId": "677fcc15f316eeb37a749afe"
    },
    "id": "67824bee15fd806c273bdeb0"
  },
  {
    "_id": "6786066f18521275cd2a39c9",
    "email": "uzirao17@gmail.com",
    "roleId": "677fcc15f316eeb37a749afa",
    "firstName": "Uzair",
    "lastName": "Shahid",
    "regionId": "",
    "officeId": "",
    "city": "",
    "street": "",
    "zipCode": "",
    "divisionId": "",
    "phoneNo": "+1 (178) 186-1541",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "deletedAt": null,
    "createdAt": "2025-01-14T06:38:39.156Z",
    "updatedAt": "2025-01-14T06:39:32.766Z",
    "role": {
      "_id": "677fcc15f316eeb37a749afa",
      "name": "CMO",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "CMO",
      "rolesParentId": "677fcc15f316eeb37a749af8"
    },
    "id": "6786066f18521275cd2a39c9"
  },
  {
    "_id": "67865ca0881debe3a98b2b54",
    "email": "newcm@gmail.com",
    "roleId": "677fcc15f316eeb37a749b02",
    "firstName": "New",
    "lastName": "CM",
    "regionId": "",
    "officeId": "6780f9da3825ccf3bcc2ba0d",
    "city": "Vitae veritatis corr",
    "street": "Blanditiis impedit",
    "zipCode": "Soluta ducimus simi",
    "divisionId": "6780f85f3825ccf3bcc2b83b",
    "phoneNo": "+1 (000) 000-0000",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "deletedAt": null,
    "createdAt": "2025-01-14T12:46:24.826Z",
    "updatedAt": "2025-01-14T12:47:20.027Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b02",
      "name": "City Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "City Manager",
      "rolesParentId": "677fcc15f316eeb37a749b00"
    },
    "id": "67865ca0881debe3a98b2b54"
  },
  {
    "_id": "6786669948e0eaf4458ac50c",
    "email": "newrm@yopmail.com",
    "roleId": "677fcc15f316eeb37a749b00",
    "firstName": "New",
    "lastName": "RM",
    "regionId": "6784bf4117965a076a7b2cd4",
    "officeId": "",
    "city": "",
    "street": "",
    "zipCode": "",
    "divisionId": "6780f85f3825ccf3bcc2b83b",
    "phoneNo": "+1 (000) 000-0008",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "deletedAt": null,
    "createdAt": "2025-01-14T13:28:57.314Z",
    "updatedAt": "2025-01-14T13:29:46.181Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b00",
      "name": "Regional Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "Regional Manager",
      "rolesParentId": "677fcc15f316eeb37a749afe"
    },
    "id": "6786669948e0eaf4458ac50c"
  },
  {
    "_id": "6787492048e0eaf4458acd3d",
    "email": "zubairshahid7@outlook.com",
    "roleId": "677fcc15f316eeb37a749b00",
    "firstName": "RM",
    "lastName": "z",
    "regionId": "6780f8533825ccf3bcc2b82a",
    "officeId": "",
    "city": "",
    "street": "",
    "zipCode": "",
    "divisionId": "6780bae93825ccf3bcc29860",
    "phoneNo": "+1 (756) 433-2343",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "deletedAt": null,
    "createdAt": "2025-01-15T05:35:28.985Z",
    "updatedAt": "2025-01-15T05:36:16.671Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b00",
      "name": "Regional Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "Regional Manager",
      "rolesParentId": "677fcc15f316eeb37a749afe"
    },
    "id": "6787492048e0eaf4458acd3d"
  },
  {
    "_id": "67876fc348e0eaf4458ad821",
    "email": "cm2@gmail.com",
    "roleId": "677fcc15f316eeb37a749b02",
    "firstName": "C",
    "lastName": "M 2",
    "regionId": "",
    "officeId": "6786614a881debe3a98b3136",
    "city": "",
    "street": "",
    "zipCode": "",
    "divisionId": "6780fb943825ccf3bcc2bd02",
    "phoneNo": "+1 (618) 798-7982",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "email sent",
    "deletedAt": null,
    "createdAt": "2025-01-15T08:20:19.222Z",
    "updatedAt": "2025-01-15T08:20:19.222Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b02",
      "name": "City Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "City Manager",
      "rolesParentId": "677fcc15f316eeb37a749b00"
    },
    "id": "67876fc348e0eaf4458ad821"
  },
  {
    "_id": "6787707748e0eaf4458ad83c",
    "email": "cm3@gmail.com",
    "roleId": "677fcc15f316eeb37a749b02",
    "firstName": "C",
    "lastName": "M 3",
    "regionId": "",
    "officeId": "6786614a881debe3a98b3136",
    "city": "",
    "street": "",
    "zipCode": "",
    "divisionId": "6780f85f3825ccf3bcc2b83b",
    "phoneNo": "+1 (867) 136-5168",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "email sent",
    "deletedAt": null,
    "createdAt": "2025-01-15T08:23:19.221Z",
    "updatedAt": "2025-01-15T08:23:19.221Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b02",
      "name": "City Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "City Manager",
      "rolesParentId": "677fcc15f316eeb37a749b00"
    },
    "id": "6787707748e0eaf4458ad83c"
  },
  {
    "_id": "6787719548e0eaf4458ad88f",
    "email": "cm4@gmail.com",
    "roleId": "677fcc15f316eeb37a749b02",
    "firstName": "C",
    "lastName": "M 4",
    "regionId": "6780fa283825ccf3bcc2bad6",
    "officeId": "67866158881debe3a98b31e0",
    "city": "",
    "street": "",
    "zipCode": "",
    "divisionId": "6780f85f3825ccf3bcc2b83b",
    "phoneNo": "+1 (874) 764-8746",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "email sent",
    "deletedAt": null,
    "createdAt": "2025-01-15T08:28:05.481Z",
    "updatedAt": "2025-01-15T08:28:05.481Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b02",
      "name": "City Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "City Manager",
      "rolesParentId": "677fcc15f316eeb37a749b00"
    },
    "id": "6787719548e0eaf4458ad88f"
  },
  {
    "_id": "6787a52a48e0eaf4458ae31b",
    "email": "cm00@yopmail.com",
    "roleId": "677fcc15f316eeb37a749b02",
    "firstName": "CM",
    "lastName": "User 00",
    "regionId": "6780fba33825ccf3bcc2bd19",
    "officeId": "67866158881debe3a98b31e0",
    "city": "Fugit architecto oc",
    "street": "Cumque nihil suscipi",
    "zipCode": "Natus ipsum tempor i",
    "divisionId": "6780fa343825ccf3bcc2bb01",
    "phoneNo": "+1 (000) 000-0009",
    "companyId": "677fcc13f316eeb37a749ae3",
    "createdByUserId": "",
    "type": "user",
    "status": "active",
    "deletedAt": null,
    "createdAt": "2025-01-15T12:08:10.685Z",
    "updatedAt": "2025-01-15T12:08:45.236Z",
    "role": {
      "_id": "677fcc15f316eeb37a749b02",
      "name": "City Manager",
      "companyId": "677fcc13f316eeb37a749ae3",
      "description": "City Manager",
      "rolesParentId": "677fcc15f316eeb37a749b00"
    },
    "id": "6787a52a48e0eaf4458ae31b"
  }
]

export const USER_STATUS_OPTIONS = [
  { value: 'email sent', label: 'Email Sent' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  // { value: 'rejected', label: 'Rejected' },
];

export const STATUS_OPTIONS_CRM = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Archived Leads',
    value: 'Archived Leads',
  },
  // {
  //   label: 'Appointments',
  //   value: 'Appointments',
  // },
];

export const APPOINTMENT_STATUS_OPTIONS = [
  { value: 'go_back', label: 'Go Back' },
  { value: 'converted', label: 'Converted' },
  // { value: 'rejected', label: 'Rejected' },
];
export const USER_STATUS_OPTIONS2 = [
  // { value: 'email sent', label: 'Email Sent' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  // { value: 'rejected', label: 'Rejected' },
];
export const division = [
  { value: 'Gutter Systems', label: 'Gutter Systems' },
  { value: 'Water Solution', label: 'Water Solution' },
  { value: 'Home Safety', label: 'Home Safety' },
];
export const campaign_types = [
  { value: 'Scan', label: 'Scan' },
  { value: 'Wrap', label: 'Wrap' },
];
export const hardCodeRoles = ['VP', 'CMO', 'Technical Manager'];

export const _userAbout = {
  id: _mock.id(1),
  role: _mock.role(1),
  email: _mock.email(1),
  country: countries[1].label,
  school: _mock.companyName(2),
  company: _mock.companyName(1),
  coverUrl: _mock.image.cover(3),
  totalFollowers: _mock.number.nativeL(1),
  totalFollowing: _mock.number.nativeL(2),
  quote:
    'Tart I love sugar plum I love oat cake. Sweet roll caramels I love jujubes. Topping cake wafer..',
  socialLinks: {
    facebook: `https://www.facebook.com/caitlyn.kerluke`,
    instagram: `https://www.instagram.com/caitlyn.kerluke`,
    linkedin: `https://www.linkedin.com/in/caitlyn.kerluke`,
    twitter: `https://www.twitter.com/caitlyn.kerluke`,
  },
};

export const _userFollowers = [...Array(18)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.fullName(index),
  country: countries[index + 1].label,
  avatarUrl: _mock.image.avatar(index),
}));

export const _userFriends = [...Array(18)].map((_, index) => ({
  id: _mock.id(index),
  role: _mock.role(index),
  name: _mock.fullName(index),
  avatarUrl: _mock.image.avatar(index),
}));

export const _userGallery = [...Array(12)].map((_, index) => ({
  id: _mock.id(index),
  postedAt: _mock.time(index),
  title: _mock.postTitle(index),
  imageUrl: _mock.image.cover(index),
}));

export const _userFeeds = [...Array(3)].map((_, index) => ({
  id: _mock.id(index),
  createdAt: _mock.time(index),
  media: _mock.image.travel(index + 1),
  message: _mock.sentence(index),
  personLikes: [...Array(20)].map((__, personIndex) => ({
    name: _mock.fullName(personIndex),
    avatarUrl: _mock.image.avatar(personIndex + 2),
  })),
  comments: (index === 2 && []) || [
    {
      id: _mock.id(7),
      author: {
        id: _mock.id(8),
        avatarUrl: _mock.image.avatar(index + 5),
        name: _mock.fullName(index + 5),
      },
      createdAt: _mock.time(2),
      message: 'Praesent venenatis metus at',
    },
    {
      id: _mock.id(9),
      author: {
        id: _mock.id(10),
        avatarUrl: _mock.image.avatar(index + 6),
        name: _mock.fullName(index + 6),
      },
      createdAt: _mock.time(3),
      message:
        'Etiam rhoncus. Nullam vel sem. Pellentesque libero tortor, tincidunt et, tincidunt eget, semper nec, quam. Sed lectus.',
    },
  ],
}));

export const _userCards = [...Array(21)].map((_, index) => ({
  id: _mock.id(index),
  role: _mock.role(index),
  name: _mock.fullName(index),
  coverUrl: _mock.image.cover(index),
  avatarUrl: _mock.image.avatar(index),
  totalFollowers: _mock.number.nativeL(index),
  totalPosts: _mock.number.nativeL(index + 2),
  totalFollowing: _mock.number.nativeL(index + 1),
}));

export const _userPayment = [...Array(3)].map((_, index) => ({
  id: _mock.id(index),
  cardNumber: ['**** **** **** 1234', '**** **** **** 5678', '**** **** **** 7878'][index],
  cardType: ['mastercard', 'visa', 'visa'][index],
  primary: index === 1,
}));

export const _userAddressBook = [...Array(4)].map((_, index) => ({
  id: _mock.id(index),
  primary: index === 0,
  name: _mock.fullName(index),
  phoneNumber: _mock.phoneNumber(index),
  fullAddress: _mock.fullAddress(index),
  addressType: (index === 0 && 'Home') || 'Office',
}));

export const _userInvoices = [...Array(10)].map((_, index) => ({
  id: _mock.id(index),
  invoiceNumber: `INV-199${index}`,
  createdAt: _mock.time(index),
  price: _mock.number.price(index),
}));

export const _userPlans = [
  {
    subscription: 'basic',
    price: 0,
    primary: false,
  },
  {
    subscription: 'starter',
    price: 4.99,
    primary: true,
  },
  {
    subscription: 'premium',
    price: 9.99,
    primary: false,
  },
];

export const _userList = [...Array(20)].map((_, index) => ({
  id: _mock.id(index),
  zipCode: '85807',
  state: 'Virginia',
  city: 'Rancho Cordova',
  role: _mock.role(index),
  email: _mock.email(index),
  address: '908 Jack Locks',
  name: _mock.fullName(index),
  isVerified: _mock.boolean(index),
  company: _mock.companyName(index),
  country: countries[index + 1].label,
  avatarUrl: _mock.image.avatar(index),
  phoneNumber: _mock.phoneNumber(index),
  status:
    (index % 2 && 'pending') || (index % 3 && 'banned') || (index % 4 && 'rejected') || 'active',
}));
